import React from "react";
import LazyLoad from "react-lazy-load";
import { useProductData } from "@/zustand/productStore.js";
import { useCartData } from "@/zustand/cartStore.js";
import { useCalculateUpsellCardPrice } from "@children/func/orderCalculations.js";
import DiscountTagBlock from "@/components/orderSummary/DiscountTagBlock";
import glideImage from "@/func/glideImage.js";
import { useUpsellData } from "@children/zustand/upsellStore";

const ProductCardUpsell = ({ product }) => {
  const { selectedProduct, warrantyState } = useCartData();
  const { upsellProduct } = useUpsellData();
  const { upsellPrice, oldPrice } = useCalculateUpsellCardPrice(upsellProduct, selectedProduct);
  const warrantyLabel = window.post_template.checkout_v4_products.tr_checkout_v4_products_warrantyLabel;
  const productData = useProductData();
  const discountAppliedLabel = window.post_template?.checkout_v4_summary?.tr_checkout_v4_discountApplied;
  const productImage = glideImage(product?.product_list_product_image, { w: 64, h: 64, fit: "crop" });
  const formattedPrice = productData?.formatted_string?.replace(/(0\.00|0,00|0)/, upsellPrice);

  return (
    <div className="productCard">
      <div className="productCard__imageContainer" style={{ height: "64px" }}>
        {productImage ? (
          <LazyLoad height={64} width={64}>
            <img
              src={productImage}
              alt={general_settings.brand_name}
              style={{ height: "64px" }}
              height="64"
              width="64"
              className="mon-img-64-w mon-img-64-h"
            />
          </LazyLoad>
        ) : (
          <div style={{ height: "64px", width: "64px", background: "red" }}></div>
        )}
        <span data-cy="summary-product-amount" className="productCard__imageContainer__indicator">
          {selectedProduct?.amount}
        </span>
      </div>
      <div className="productCard__titleBlock">
        <div data-cy="summary-product-title" className="productCard__titleBlock__title">
          {product?.product_display_name} {warrantyState && <span>{warrantyLabel}</span>}
        </div>
        {product?.additional_text && (
          <div className="productCard__titleBlock__altText" style={{ margin: "0" }}>
            {product?.additional_text}
          </div>
        )}
        {window?.post_template?.checkout_v4_products?.checkout_v4_products_discountAppliedToggle && (
          <DiscountTagBlock discountAppliedLabel={discountAppliedLabel} />
        )}
      </div>
      <div className="productCard__priceBlock">
        {oldPrice && <span className="productCard__priceBlock__oldPrice">{oldPrice}</span>}
        {formattedPrice && <span className="productCard__priceBlock__price">{formattedPrice}</span>}
      </div>
    </div>
  );
};

export default ProductCardUpsell;
